// extracted by mini-css-extract-plugin
export default {"dicomLink":"dicomLink_LJ79i","type":"type_lLbVz","square":"square_RXR_t"};